import React from 'react';

// devExtreme
import Button from 'devextreme-react/button';

// i18n
import { useTranslation } from '@core/hooks';

interface ActionBtnsProps {
  handleSave: () => void;
  handleCancel: () => void;
  customSaveText?: string;
  customCancelText?: string;
  saveDisabled?: boolean;
  cancelDisabled?: boolean;
  hideSaveBtn?: boolean;
  hideCancelBtn?: boolean;
  className?: string;
}

const ActionBtns: React.FC<ActionBtnsProps> = ({
  handleSave,
  handleCancel,
  customSaveText,
  customCancelText,
  saveDisabled = false,
  cancelDisabled = false,
  hideSaveBtn = false,
  hideCancelBtn = false,
  className,
  children
}) => {
  const { t } = useTranslation();

  const denyPropagation = (ev: any, handler: () => void) => {
    ev.stopPropagation();

    handler();
  };

  return (
    <div className={`action-btns ${!className ? '' : className}`}>
      {children}
      {!hideSaveBtn && (
        <Button
          disabled={saveDisabled}
          text={customSaveText || t('Zapisz')}
          onClick={(e) => denyPropagation(e.event, handleSave)}
        />
      )}
      {!hideCancelBtn && (
        <Button
          disabled={cancelDisabled}
          text={customCancelText || t('Anuluj')}
          onClick={(e) => denyPropagation(e.event, handleCancel)}
        />
      )}
    </div>
  );
};

export default ActionBtns;
